// extracted by mini-css-extract-plugin
module.exports = {"authButtonsContainer":"auth-buttons_authButtonsContainer___GG9c","authButton":"auth-buttons_authButton__vyOzR"};